import {post} from '@/utils/request';
import {erpserver,attendanceserver} from '@/utils/baseUrl';
//获取班次列表
export async function getbcdetailList(params) {
    return post(attendanceserver+'/kq/getbcdetailList', params, true)
}
//新增编辑保存接口
export async function addedit(params) {
    return post(attendanceserver+'/kq/addedit', params, true)
}
//禁用启动编辑接口
export async function usechange(params) {
    return post(attendanceserver+'/kq/usechange', params, true)
}
//获取岗位列表
export async function positionlist(params) {
    return post(attendanceserver+'/attendence/positionlist', params, true)
}